import React from "react";

const AnimationSection = () => {
    return (
        <section className="w-full bg-[#1677ff]">
            <video
                className="w-full h-[300px] md:h-[400px] object-cover"
                src="/assets/videos/logo-animation-dark.mp4"
                autoPlay
                muted
                loop
                playsInline
            />
        </section>
    );
};

export default AnimationSection;